<template>
  <footer
    v-if="!isFullscreen"
    class="footer-license"
    :class="{ 'footer-license--collapsed': isSidebarCollapsed }"
  >
    <div class="footer-license__inner">
      <nav class="footer-license__links" aria-label="پیوندهای شرکت">
        <a
          href="https://www.sinapardazesh.ir/%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d9%85%d8%a7/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-license__link"
        >
          درباره ما
        </a>
        <span class="footer-license__separator">|</span>
        <a
          href="https://www.sinapardazesh.ir/%d8%aa%d9%84%d9%81%d9%86%d8%8c-%d9%be%d8%b3%d8%aa-%d8%a7%d9%84%da%a9%d8%aa%d8%b1%d9%88%d9%86%db%8c%da%a9%d8%8c-%d9%86%d8%b4%d8%a7%d9%86%db%8c/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-license__link"
        >
          تماس با ما
        </a>
        <span class="footer-license__separator footer-license__sinarem-separator">|</span>
        <a
          href="https://www.sinapardazesh.ir/sinarem/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-license__link footer-license__sinarem"
        >
          دانلود سینارِم
        </a>
      </nav>
      <p class="footer-license__text">
        تمام حقوق مادی و معنوی این سامانه، متعلق به شرکت سیناپردازش نوین آریا است.
      </p>
    </div>
  </footer>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import './Style.js';

defineProps({
  isSidebarCollapsed: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const isFullscreen = computed(() => route.query.fullscreen === '1');
</script>
